<sdps-divider variation="secondary"></sdps-divider>
<div id="cash-label-container">
  <span id="section-title">Cash</span>
</div>
<div id="cash-input-container" [formGroup]="parentForm">
  <div class="row" formArrayName="cashAmounts">
      <div *ngFor="let toAccountForm of toAccounts.controls; let receivingAccountIndex = index">
        <div [formGroupName]="receivingAccountIndex" class="cash-input-and-gross-net-selector">
          <div class="label-and-cash-input">
            <div class="label-name">{{toAccountList[receivingAccountIndex].amountLabelName}}</div>
            <div class="amount-fields">
              <div class="multiple-cash-input">
                <mm-amount-field [label]="'Amount'" [autoCalculateRmd$]="autoCalculateRmd$" [iraFields]="iraFields" [frequency$]="frequency$" [parentForm]="getToAccount(receivingAccountIndex)">
                </mm-amount-field>
              </div>
              <div class="gross-net-selector" *ngIf="isIraTransaction" data-testid="grossNetSelector">
                <mm-amount-type-selector
                  [prefilledValue]="getAmountTypeSelection(receivingAccountIndex)" [autoCalculateRmd$]="autoCalculateRmd$" 
                  [parentForm]="getToAccount(receivingAccountIndex)" [isPJLS]="true" [PJLSindex]="receivingAccountIndex" 
                  [controlDisabled]="isOneTimeTotalDist" [distributionReasonDescription$]="distributionReasonDescriptionArr$[receivingAccountIndex]" 
                  [isFirstPartyIraToIraJournal$]="isFirstPartyIraToIraJournalArr$[receivingAccountIndex]">
                </mm-amount-type-selector>
              </div>
              <div class="vertical-line" *ngIf="toAccounts.controls.length > 1 && toAccounts.controls.length !== receivingAccountIndex+1"></div>
            </div>
          </div>
        </div>
      </div>
  </div>
</div>

